<template>
    <card>
        <div class="card-body">
            <div class="heading">Appointment</div>

            <div class="text-feature align-top">
                <img class="inline mr-1" src="../../../assets/images/calendar.svg" alt="" />
                {{ appointmentDate.format('HH:mm - dddd Do MMMM') }}
            </div>

            <div v-if="appointmentData.clinic.ClinicID != videoClinicID" class="text-feature align-top">
                <img class="inline mr-1" src="../../../assets/images/map-marker-blue.svg" alt="" />
                {{ appointmentData.clinic.ClinicName }}
            </div>

            <div class="mt-4 text-sm">Clinician</div>

            <div class="text-feature">
                {{ appointmentData.therapist.Name }}
            </div>
        </div>
    </card>
</template>

<script>
    import Card from '../../Block/Card';

    import { mapState } from 'vuex';
    import DateTime from "../../../lib/DateTime";

    export default {
        name: 'appointment-info',

        components: {
            Card,
        },

        computed: {
            ...mapState('appointment', ['appointmentData']),

            appointmentDate() {
                return DateTime.merge(
                    this.appointmentData.appointment.Date, this.appointmentData.appointment.Time
                );
            },

            videoClinicID() {
                return process.env.VUE_APP_VIDEO_CLINIC_ID;
            },
        },
    }
</script>
